(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aeoluspetuk-collection-description"] && !Shopify.designMode) return;
  try {
    
function initCollectionDescriptionToggle(section){

    const content = section.querySelector('[data-description]');
    const button = section.querySelector('[data-toggle]');

    if (!content || !button) return;

    button.addEventListener('click', function(){

        content.classList.toggle('is-expanded');

        if(content.classList.contains('is-expanded')){
            button.textContent = button.dataset.less;
        }else{
            button.textContent = button.dataset.more;
        }

    });
}

function initAllCollectionDescriptions(){
    document.querySelectorAll('.collection-description-section').forEach(initCollectionDescriptionToggle);
}

initAllCollectionDescriptions();

document.addEventListener('shopify:section:load', initAllCollectionDescriptions);

  } catch(e) { console.error(e); }
})();
})();
